function ClearButton({ onClick }) {
  return <button onClick={() => onClick()} className="btn btn-block btn-danger">C</button>;
}

export default ClearButton;
